module.exports = __webpack_public_path__ + "static/media/MinusCircleOutlined.be6156c5.svg";